// 默认菜单
export const defaultMenuNames = [
  'MaterialList',
  'DesignPro',
  'DesignOrderIndex',
  'GoodsIndex',
  'ProductionOrder',
  'SupplierManage',
  'MaterialPurchase',
  'sysConfigIndex',
];

// 可见角色/用户
export const VISIBLE_TYPE = {
  ROLE: 2,
  USER: 3,
};

/** 自定义板块常量
  ■ 1-常用功能
  ■ 2-近90天生产数据
  ■ 3-本月设计款数
  ■ 4-本月设计师设计款数
  ■ 5-本月车版完成数
  ■ 6-本月纸样完成数
  ■ 7-近30天设计转换统计
  ■ 8-下单/裁床/已入库
  ■ 9-工序外发/回收
  ■ 10-面料统计
  ■ 11-辅料统计
  ■ 12-生产单进度
  ■ 13-消息通知
  ■ 14-代办任务
  ■ 15-审批
 */
export const VIEW_MODULE = {
  CUSTOM_FUN: 1,
  PRODUCTION_DATA: 2,
  DESIGN_COUNT: 3,
  DESIGN_COUNT_BY_DESIGNER: 4,
  SWEEP_TEMPLATE_REPORT_NUMBER: 5,
  PATTERN_REPORT_NUMBER: 6,
  DESIGN_AND_DESIGN_ORDER_COUNT: 7,
  PRODUCE_ORDER_NUMBER: 8,
  OUTWARD_ORDER_NUMBER: 9,
  FABRIC_NUMBER: 10,
  NOT_FABRIC_NUMBER: 11,
  PRODUCE_ORDER_PROGRESS: 12,
  MESSAGE_NOTIFY: 13,
  TODO_TASK: 14,
  FLOW_INSTANCE: 15,
} as const;

// VIEW_MODULE 的 key 类型
export type ViewModuleKey = keyof typeof VIEW_MODULE;

// 自定义板块常量
export const DEFAULT_BLOCKS = [
  VIEW_MODULE.CUSTOM_FUN,
  VIEW_MODULE.MESSAGE_NOTIFY,
  VIEW_MODULE.TODO_TASK,
  VIEW_MODULE.FLOW_INSTANCE,
];

export const customBlockList = [
  {
    name: '常用功能',
    module: VIEW_MODULE.CUSTOM_FUN,
    description: '快捷功能入口',
    tips: '默认可见（具体功能由对应角色权限控制是否可进入详情）',
  },
  {
    name: '近90天生产数据',
    module: VIEW_MODULE.PRODUCTION_DATA,
    description: '关键生产数据统计',
  },
  {
    name: '本月设计款数',
    module: VIEW_MODULE.DESIGN_COUNT,
    description: '统计本月设计师新增的设计款数，按商品一级分类展示数据',
  },
  {
    name: '本月设计师设计款数',
    module: VIEW_MODULE.DESIGN_COUNT_BY_DESIGNER,
    description: '统计本月设计师新增的设计款数，标准：按照设计师字段判断',
  },
  {
    name: '本月车版完成数',
    module: VIEW_MODULE.SWEEP_TEMPLATE_REPORT_NUMBER,
    description: '统计本月完成的车版数',
  },
  {
    name: '本月纸样完成数',
    module: VIEW_MODULE.PATTERN_REPORT_NUMBER,
    description: '统计本月完成的纸样数',
  },
  {
    name: '近30天设计转换统计',
    module: VIEW_MODULE.DESIGN_AND_DESIGN_ORDER_COUNT,
    description: '显示设计款不同阶段的流转情况',
  },
  {
    name: '下单/裁床/已入库',
    module: VIEW_MODULE.PRODUCE_ORDER_NUMBER,
    description: '显示最近7天的下单数、裁床数、已入库（非成品入库数）',
  },
  {
    name: '工序外发/回收',
    module: VIEW_MODULE.OUTWARD_ORDER_NUMBER,
    description: '显示最近7天的工序外发数、回收数',
  },
  {
    name: '面料统计',
    module: VIEW_MODULE.FABRIC_NUMBER,
    description: '采购、领料统计',
  },
  {
    name: '辅料统计',
    module: VIEW_MODULE.NOT_FABRIC_NUMBER,
    description: '采购、领料统计',
  },
  {
    name: '生产单进度',
    module: VIEW_MODULE.PRODUCE_ORDER_PROGRESS,
    description:
      '显示近90天下单未完成的生产单的进度情况，不包含草稿、已撤销、已完成；',
  },
  {
    name: '消息通知',
    module: VIEW_MODULE.MESSAGE_NOTIFY,
    description: '显示最新的消息通知',
    tips: '默认可见',
  },
  {
    name: '待办任务',
    module: VIEW_MODULE.TODO_TASK,
    description: '显示当前账号需要执行的任务，默认按照截止日期升序',
    tips: '默认可见',
  },
  {
    name: '审批',
    module: VIEW_MODULE.FLOW_INSTANCE,
    description: '显示当前账号需要执行的审批，默认按照截止日期升序',
    tips: '默认可见',
  },
];
